<template>
  <page-header-wrapper>
    <div class="outbound-page erp-list-page baidao-list-page outbound-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item label="日期范围"><a-range-picker v-model="dateRange" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="出库单号"><a-input v-model="query.outboundNo" allow-clear placeholder="请输入出库单号" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="客商"><a-input v-model="query.customerKeyword" allow-clear placeholder="客商编号或名称" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="审核状态"><a-select v-model="query.auditStatus" allow-clear placeholder="全部"><a-select-option value="unaudited">未审核</a-select-option><a-select-option value="audited">已审核</a-select-option><a-select-option value="reverse_audited">已反审核</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="结算状态"><a-select v-model="query.settlementStatus" allow-clear placeholder="全部"><a-select-option value="unsettled">未结算</a-select-option><a-select-option value="settled">已结算</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="订单号"><a-input v-model="query.sourceOrderNo" allow-clear placeholder="请输入销售订单号" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="出货分库"><a-select v-model="query.warehouseId" allow-clear show-search option-filter-prop="children" placeholder="全部仓库"><a-select-option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">{{ warehouse.warehouseCode }} · {{ warehouse.warehouseName }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="业务员"><a-select v-model="query.salesUserId" allow-clear show-search option-filter-prop="children" placeholder="全部业务员"><a-select-option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.nickName || user.userName }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="search">查询</a-button><a-button icon="redo" @click="reset">重置</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>销售出库单</h3><p>由已审核销售订单生成；草稿不扣库存，审核后以本单金额作为对账依据。</p></div>
          <div class="erp-toolbar-actions">
            <a-button icon="printer" :disabled="!selectedRowKeys.length" :loading="batchPrinting" @click="printSelected">批量打印</a-button>
            <a-button type="primary" icon="plus" @click="openCreate">新建出库单</a-button>
          </div>
        </div>
        <a-table
          :row-key="rowKey"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          bordered
          size="middle"
          :scroll="{ x: 3460 }"
          :row-selection="rowSelection"
          @change="onPageChange">
          <template slot="number" slot-scope="value, record"><a @click="openDetail(record)">{{ value }}</a><a-tag v-if="record.documentDirection === 'return'" color="volcano" class="direction-tag">退货</a-tag></template>
          <template slot="status" slot-scope="value, record"><a-tag class="erp-status-tag" :color="record.voidStatus === 'voided' ? 'default' : statusColor(value)">{{ record.voidStatus === 'voided' ? '已作废' : statusText(value) }}</a-tag></template>
          <template slot="money" slot-scope="value"><span class="erp-money">¥{{ formatMoney(value) }}</span></template>
          <template slot="moneyOrEmpty" slot-scope="value"><span v-if="value !== null && value !== undefined" class="erp-money">¥{{ formatMoney(value) }}</span><span v-else>—</span></template>
          <template slot="salesUser" slot-scope="value">{{ displayValue(value) }}</template>
          <template slot="warehouse" slot-scope="value">{{ warehouseName(value) || '—' }}</template>
          <template slot="settlementStatus" slot-scope="value">{{ settlementStatusText(value) }}</template>
          <template slot="settlementMethod" slot-scope="value">{{ optionLabel(settlementMethodOptions, value) }}</template>
          <template slot="deliveryMethod" slot-scope="value">{{ optionLabel(deliveryMethodOptions, value) }}</template>
          <template slot="emptyValue" slot-scope="value">{{ displayValue(value) }}</template>
          <template slot="actions" slot-scope="value, record">
            <a @click="openDetail(record)">查看</a>
            <a-divider type="vertical" />
            <a v-if="printingId !== rowPrintKey(record)" @click.prevent="printRow(record)">打印</a>
            <span v-else style="color:rgba(0,0,0,.45)">打印中…</span>
            <template v-if="record.voidStatus !== 'voided' && record.auditStatus !== 'audited'"> <a-divider type="vertical" /><a @click="openDetail(record, true)">编辑</a><a-divider type="vertical" /><a @click="confirmAction('审核', record, auditSalesOutbound)">审核</a></template>
            <template v-if="record.voidStatus !== 'voided' && record.auditStatus === 'audited'"> <a-divider type="vertical" /><a @click="confirmAction('反审核', record, reverseAuditSalesOutbound)">反审核</a></template>
            <template v-if="record.voidStatus !== 'voided' && record.auditStatus !== 'audited'"> <a-divider type="vertical" /><a @click="confirmAction('作废', record, voidSalesOutbound)">作废</a></template>
            <template v-if="record.voidStatus === 'voided'"> <a-divider type="vertical" /><a class="erp-danger-link" @click="confirmAction('删除', record, deleteSalesOutbound)">删除</a></template>
          </template>
        </a-table>
      </div>
      <a-drawer
        :visible="drawerVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-doc-drawer baidao-drawer-sample outbound-drawer"
        @close="closeDrawer">
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header">
            <div><button class="erp-back-button" type="button" title="返回销售出库列表" aria-label="返回销售出库列表" @click="closeDrawer"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看单据' : (form.id ? '编辑单据' : '新建单据') }}</span><h3>{{ form.outboundNo || '新建销售出库单' }}</h3></div>
            <div><a-button @click="closeDrawer">取消</a-button><a-button v-if="editable" type="primary" :loading="saving" @click="save">保存</a-button></div>
          </header>
          <div class="erp-drawer-content">
            <div class="erp-status-strip"><a-tag class="erp-status-tag" :color="form.auditStatus === 'audited' ? 'green' : (form.auditStatus === 'reverse_audited' ? 'blue' : 'orange')">{{ statusText(form.auditStatus) }}</a-tag><span v-if="form.auditStatus === 'audited'">{{ isReturn ? '已按原出库成本回补库存；负数金额已锁定作为退货结算依据。' : '已审核并扣减库存；单价、税率及明细不可再修改。' }}</span><span v-else-if="form.auditStatus === 'reverse_audited'">{{ isReturn ? '退货入库已反冲；可编辑后重新审核，或先作废再删除。' : '库存、成本和订单剩余量已恢复；可编辑后重新审核，或先作废再删除。' }}</span><span v-else>保存仅生成草稿；审核时重新校验来源单据、数量和库存。</span></div>
            <section class="erp-form-card">
              <div class="erp-section-title"><span class="erp-section-index">01</span><div><h4>基础信息</h4><p>客户、经营主体和出库仓库由来源订单带出</p></div></div>
              <div class="erp-base-grid">
                <label><span><b class="erp-required">*</b> 业务方向</span><a-select v-model="form.documentDirection" :disabled="!editable || !!form.id || !!form.items.length" @change="directionChanged"><a-select-option value="outbound">正常出库</a-select-option><a-select-option value="return">销售退货（负数）</a-select-option></a-select></label>
                <label><span><b class="erp-required">*</b> 出库日期</span><a-date-picker v-model="form.outboundDate" value-format="YYYY-MM-DD" style="width:100%" :disabled="!editable" /></label>
                <label><span>客户</span><a-input :value="form.customerName || '选择来源订单后带出'" disabled /></label>
                <label><span>{{ isReturn ? '退货入库仓' : '出库仓库' }}</span><a-select
                  v-if="isReturn"
                  v-model="form.warehouseId"
                  :disabled="!editable || !form.operatingSubjectId"
                  show-search
                  option-filter-prop="children"
                  placeholder="选择原出库明细后默认原仓"><a-select-option v-for="warehouse in subjectWarehouses" :key="warehouse.id" :value="warehouse.id">{{ warehouse.warehouseCode }} · {{ warehouse.warehouseName }}</a-select-option></a-select><a-input v-else :value="warehouseName(form.warehouseId) || '选择来源订单后带出'" disabled /></label>
                <label><span>经营主体 ID</span><a-input :value="form.operatingSubjectId == null ? '选择来源订单后带出' : String(form.operatingSubjectId)" disabled /></label>
                <label><span>整单折扣金额</span><a-input-number v-model="form.wholeDiscountAmount" :disabled="!editable || isReturn" :min="0" :precision="2" style="width:100%" /></label>
                <label><span>预收款账户</span><a-input v-model="form.prepaidAccountName" :disabled="!editable" placeholder="选填" /></label>
                <label class="wide"><span>备注</span><a-input v-model="form.remark" :disabled="!editable" placeholder="记录出库说明（选填）" /></label>
                <label class="wide"><span>附件</span><file-upload
                  :value="form.attachmentUrl || ''"
                  type="file"
                  field-name="attachmentUrl"
                  :count="3"
                  :disabled="!editable"
                  @change="attachmentChanged" /></label>
              </div>
            </section>
            <section class="erp-form-card">
              <div class="erp-section-heading-row"><div class="erp-section-title"><span class="erp-section-index">02</span><div><h4>来源订单与出库明细</h4><p>{{ isReturn ? '单位带自原出库单；数量按该单位录入，审核后换算成基本单位增加库存' : '单位带自销售订单；数量按该单位录入，审核后换算成基本单位扣减库存' }}</p></div></div><a-button v-if="editable" type="primary" ghost icon="plus" @click="openSourcePicker">选择订单</a-button></div>
              <div v-if="!form.items.length" class="empty-lines"><a-empty description="暂无出库明细，请先选择来源销售订单" /></div>
              <div v-else class="erp-line-table-wrap"><table class="erp-line-table outbound-line-table"><thead><tr><th>来源订单 / SKU</th><th>单位</th><th>{{ isReturn ? '原出库 / 剩余可退' : '订单当前剩余' }}</th><th>{{ isReturn ? '退货数量（负数）' : '出库数量' }}</th><th>出库单价</th><th>税率 %</th><th>税额（系统计算）</th><th>价税合计</th><th v-if="editable">操作</th></tr></thead><tbody>
                <tr v-for="(item, index) in form.items" :key="item.sourceOrderItemId + '-' + index">
                  <td class="source-cell"><strong>{{ item.sourceOrderNo || item.sourceOrderId }}</strong><span>{{ item.skuCode }} · {{ item.skuName }}</span></td>
                  <td><a-input :value="item.unitName || '—'" size="small" disabled style="width:88px" /></td>
                  <td><template v-if="isReturn"><strong>{{ item.sourceOutboundNo }}</strong><br><span>{{ item.qtyReturnable }} {{ item.unitName }}</span></template><template v-else>{{ item.qtyRemaining == null ? '—' : item.qtyRemaining }} {{ item.unitName }}</template></td>
                  <td><a-input-number
                    v-model="item.qtyBusiness"
                    :min="isReturn ? -Number(item.qtyReturnable || 0) : 0.000001"
                    :max="isReturn ? -0.000001 : undefined"
                    :precision="6"
                    :disabled="!editable"
                    style="width:130px" /></td>
                  <td><a-input-number v-model="item.salePrice" :min="0" :precision="2" :disabled="!editable" style="width:105px" /></td>
                  <td><a-input-number v-model="item.taxRate" :min="0" :precision="4" :disabled="!editable" style="width:90px" /></td>
                  <td><span class="readonly-tax">¥{{ lineTax(item) }}</span></td>
                  <td class="erp-money">¥{{ lineTotal(item) }}</td>
                  <td v-if="editable"><a class="erp-danger-link" @click="form.items.splice(index, 1)">移除</a></td>
                </tr>
              </tbody></table></div>
              <div class="outbound-summary"><span>共 {{ form.items.length }} 条明细</span><div><span>出库金额 <b>¥{{ totalAmount }}</b></span><span>税额 <b>¥{{ totalTax }}</b></span><span>价税合计 <b>¥{{ totalWithTax }}</b></span><span>整单折扣 <b>¥{{ discountAmount }}</b></span><span>折后实际金额 <strong>¥{{ actualAmount }}</strong></span></div></div>
            </section>
          </div>
          <footer class="erp-drawer-footer"><div><a-icon type="info-circle" /> {{ isReturn ? '审核后按原出库单位换算成基本单位增加库存。' : '审核后按销售订单单位换算成基本单位扣减库存。' }}反审核前必须清理有效下游单据。</div><div><a-button @click="closeDrawer">返回列表</a-button><a-button v-if="editable" type="primary" :loading="saving" @click="save">保存草稿</a-button></div></footer>
        </div>
      </a-drawer>
      <a-modal
        v-model="sourceVisible"
        title="手工新建销售出库单"
        width="94%"
        :footer="null"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-picker-modal outbound-source-modal">
        <div class="source-picker-shell">
          <div class="source-picker-intro"><strong>选择销售订单</strong><span>{{ isReturn ? '退货仅可选一张订单、一张原出库单中的可退明细' : '一次只能选择一张已审核销售订单' }}</span></div>
          <div class="source-search-grid">
            <label><span>客户</span><a-input v-model="sourceQuery.customerName" allow-clear placeholder="请输入客户名称" @pressEnter="loadSources" /></label>
            <label class="keyword"><span>单据/商品关键词</span><a-input v-model="sourceQuery.keyword" allow-clear placeholder="销售订单号、商品编码、商品名称" @pressEnter="loadSources" /></label>
            <div class="source-search-actions"><a-button type="primary" icon="search" @click="loadSources">搜索</a-button><a-button icon="redo" @click="resetSourceSearch">重置</a-button></div>
          </div>
          <section class="source-picker-panel order-panel">
            <div class="source-panel-heading"><strong>销售订单</strong><span>已选 <b>{{ sourceSelectedOrderIds.length }}</b> 单</span></div>
            <a-table
              :key="'source-order-table-' + sourceSelectionVersion"
              size="small"
              :columns="sourceColumns"
              :data-source="sourceRows"
              :loading="sourceLoading"
              :pagination="sourcePagination"
              :scroll="{ x: 1050, y: 250 }"
              :row-key="record => String(record.id)"
              :row-selection="sourceOrderRowSelection"
              :row-class-name="sourceOrderRowClass"
              @change="onSourcePageChange">
              <template slot="sourceOrderNo" slot-scope="value, record"><a @click="activateSourceOrder(record, true)">{{ value }}</a></template>
              <template slot="salesUser" slot-scope="value">{{ value ? 'ID ' + value : '—' }}</template>
            </a-table>
          </section>
          <section class="source-picker-panel item-panel">
            <div class="source-panel-heading"><div><strong>{{ sourceActiveOrder ? sourceActiveOrder.orderNo + ' · 商品明细' : '商品明细' }}</strong><small v-if="sourceActiveOrder">{{ sourceActiveOrder.customerName }} · {{ warehouseName(sourceActiveOrder.deliveryWarehouseId) }}</small></div><span>当前单 {{ sourceActiveItems.length }} 行 · 累计已选 <b>{{ sourceSelectedItemCount }}</b> 行</span></div>
            <a-empty v-if="!sourceActiveOrder" description="请先在上方勾选一张销售订单" class="source-item-empty" />
            <a-table
              v-else
              size="small"
              :row-key="sourceItemRowKey"
              :columns="sourceItemColumns"
              :data-source="sourceActiveItems"
              :loading="sourceItemLoading"
              :pagination="false"
              :scroll="{ x: 980, y: 230 }"
              :row-selection="sourceItemRowSelection" />
          </section>
          <div class="source-picker-footer"><a-button @click="sourceVisible = false">取消</a-button><a-button type="primary" :disabled="!sourceSelectedItemCount" @click="addSelectedItems">下一步：生成销售出库明细</a-button></div>
        </div>
      </a-modal>
    </div>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { listWarehouse } from '@/api/erp/warehouse'
import { pageUser } from '@/api/system/user'
import { getDicts } from '@/api/system/dict/data'
import { pageSalesOutbound, getSalesOutbound, pageOutboundSourceOrders, getOutboundSourceItems, getReturnSourceItems, createSalesOutbound, updateSalesOutbound, auditSalesOutbound, reverseAuditSalesOutbound, voidSalesOutbound, deleteSalesOutbound, printSalesOutbound } from '@/api/erp/salesOutbound'
import { printPdfBlob } from '@/utils/erpDeliveryPdf'
import { getSalesOrder } from '@/api/erp/salesOrder'

const blankForm = () => ({ id: null, outboundDate: moment().format('YYYY-MM-DD'), documentDirection: 'outbound', sourceOutboundId: null, customerId: null, customerName: '', operatingSubjectId: null, warehouseId: null, auditStatus: 'unaudited', wholeDiscountAmount: 0, prepaidAccountName: '', attachmentUrl: '', remark: '', items: [] })
const amount = value => Number(value || 0).toFixed(2)
const toSalesQty = (row, field) => {
  const rate = Number(row.convertRateToBase || 1) || 1
  return Number((Number(row[field] || 0) / rate).toFixed(6))
}
export default {
  name: 'ErpSalesOutbound',
  data () {
    return {
      loading: false,
saving: false,
drawerVisible: false,
readOnly: false,
viewportWidth: window.innerWidth,
form: blankForm(),
warehouses: [],
userOptions: [],
settlementMethodOptions: [],
deliveryMethodOptions: [],
rows: [],
dateRange: [],
      query: { outboundNo: '', customerKeyword: '', auditStatus: undefined, settlementStatus: undefined, sourceOrderNo: '', warehouseId: undefined, salesUserId: undefined },
pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      sourceVisible: false,
sourceLoading: false,
sourceRows: [],
sourceQuery: { customerName: '', keyword: '' },
sourcePagination: { current: 1, pageSize: 10, total: 0 },
      sourceSelectedOrderIds: [],
sourceSelectedOrders: {},
sourceActiveOrderId: null,
sourceSelectionVersion: 0,
      sourceItemsByOrder: {},
sourceSelectedItemIdsByOrder: {},
sourceItemLoading: false,
consumingSourceOrderId: null,
consumingOutboundIdToken: null,
printingId: null,
batchPrinting: false,
selectedRowKeys: [],
selectedRecords: {},
      columns: [
        { title: '日期', dataIndex: 'outboundDate', width: 120, fixed: 'left' },
        { title: '编号', dataIndex: 'outboundNo', scopedSlots: { customRender: 'number' }, width: 225, fixed: 'left' },
        { title: '客商编号', dataIndex: 'customerCode', width: 145, scopedSlots: { customRender: 'emptyValue' } },
        { title: '客商名称', dataIndex: 'customerName', width: 180, scopedSlots: { customRender: 'emptyValue' } },
        { title: '结算金额', dataIndex: 'totalTaxAmount', scopedSlots: { customRender: 'money' }, width: 125 },
        { title: '已结金额', dataIndex: 'settledAmount', scopedSlots: { customRender: 'moneyOrEmpty' }, width: 115 },
        { title: '尚欠金额', dataIndex: 'unsettledAmount', scopedSlots: { customRender: 'moneyOrEmpty' }, width: 115 },
        { title: '整单折扣', dataIndex: 'wholeDiscountAmount', scopedSlots: { customRender: 'moneyOrEmpty' }, width: 115 },
        { title: '折后实际金额', dataIndex: 'actualAmount', scopedSlots: { customRender: 'money' }, width: 145 },
        { title: '结算状态', dataIndex: 'settlementStatus', width: 115, scopedSlots: { customRender: 'settlementStatus' } },
        { title: '结算方式', dataIndex: 'settlementMethod', width: 120, scopedSlots: { customRender: 'settlementMethod' } },
        { title: '预收款账户', dataIndex: 'prepaidAccountName', width: 145, scopedSlots: { customRender: 'emptyValue' } },
        { title: '审核状态', dataIndex: 'auditStatus', scopedSlots: { customRender: 'status' }, width: 105 },
        { title: '订单号', dataIndex: 'sourceOrderNo', width: 190, scopedSlots: { customRender: 'emptyValue' } },
        { title: '客商订单号', dataIndex: 'customerOrderNo', width: 155, scopedSlots: { customRender: 'emptyValue' } },
        { title: '相关单据', dataIndex: 'relatedDocuments', width: 155, scopedSlots: { customRender: 'emptyValue' } },
        { title: '发票号码', dataIndex: 'invoiceNo', width: 145, scopedSlots: { customRender: 'emptyValue' } },
        { title: '送货方式', dataIndex: 'deliveryMethod', width: 120, scopedSlots: { customRender: 'deliveryMethod' } },
        { title: '备注', dataIndex: 'remark', width: 170, ellipsis: true, scopedSlots: { customRender: 'emptyValue' } },
        { title: '业务员', dataIndex: 'salesUserName', scopedSlots: { customRender: 'salesUser' }, width: 130 },
        { title: '部门名称', dataIndex: 'departmentName', width: 150, scopedSlots: { customRender: 'emptyValue' } },
        { title: '出货分库', dataIndex: 'warehouseId', scopedSlots: { customRender: 'warehouse' }, width: 145 },
        { title: '操作', scopedSlots: { customRender: 'actions' }, width: 360, fixed: 'right' }
      ],
      sourceColumns: [
        { title: '销售订单号', dataIndex: 'orderNo', scopedSlots: { customRender: 'sourceOrderNo' }, width: 200 },
        { title: '单据日期', dataIndex: 'orderDate', width: 125 },
        { title: '客户', dataIndex: 'customerName', width: 220 },
        { title: '所属业务员', dataIndex: 'salesUserId', scopedSlots: { customRender: 'salesUser' }, width: 125 },
        { title: '备注', dataIndex: 'remark', ellipsis: true },
        { title: '明细行数', dataIndex: 'eligibleLineCount', width: 100, align: 'center' }
      ],
      itemColumns: [
        { title: '原出库单', dataIndex: 'sourceOutboundNo', width: 205 },
        { title: '销售属性', dataIndex: 'salesAttribute', width: 105 },
        { title: '商品编码', dataIndex: 'skuCode', width: 175 },
        { title: '商品名称', dataIndex: 'skuName', width: 240 },
        { title: '销售单位', dataIndex: 'unitName', width: 105 },
        { title: '订单数量', dataIndex: 'qtyOrder', width: 115, align: 'right' },
        { title: '已出库数量', dataIndex: 'qtyOutbound', width: 125, align: 'right', customRender: (value, record) => toSalesQty(record, 'qtyOutbound') },
        { title: '剩余可出', dataIndex: 'qtyRemaining', width: 115, align: 'right', customRender: (value, record) => toSalesQty(record, 'qtyRemaining') },
        { title: '订单单价', dataIndex: 'salePrice', width: 115, align: 'right', customRender: value => '¥' + amount(value) }
      ]
    }
  },
  computed: {
    isReturn () { return this.form.documentDirection === 'return' },
    subjectWarehouses () { return this.warehouses.filter(row => String(row.operatingSubjectId) === String(this.form.operatingSubjectId) && (!row.status || row.status === 'enabled')) },
    sourceItemColumns () {
      if (!this.isReturn) return this.itemColumns.filter(column => column.dataIndex !== 'sourceOutboundNo')
      return [
        { title: '原出库单', dataIndex: 'sourceOutboundNo', width: 205 },
        { title: '商品编码', dataIndex: 'skuCode', width: 175 },
        { title: '商品名称', dataIndex: 'skuName', width: 240 },
        { title: '销售单位', dataIndex: 'unitName', width: 105 },
        { title: '原出库数量', dataIndex: 'qtyOutbound', width: 125, align: 'right' },
        { title: '已退数量', dataIndex: 'qtyReturned', width: 115, align: 'right' },
        { title: '剩余可退', dataIndex: 'qtyReturnable', width: 115, align: 'right' },
        { title: '原出库单价', dataIndex: 'salePrice', width: 125, align: 'right', customRender: value => '¥' + amount(value) },
        { title: '原出库单位成本', dataIndex: 'originalCostPrice', width: 155, align: 'right', customRender: value => '¥' + Number(value || 0).toFixed(6) }
      ]
    },
    editable () { return !this.readOnly && this.form.auditStatus !== 'audited' && this.form.voidStatus !== 'voided' },
    drawerTitle () { return this.form.id ? (this.readOnly ? '查看' : '编辑') + '销售出库单 · ' + this.form.outboundNo : '新建销售出库单' },
    drawerWidth () { return this.viewportWidth < 1100 ? '100%' : '88%' },
    totalAmount () { return amount(this.form.items.reduce((sum, item) => sum + Number(item.qtyBusiness || 0) * Number(item.salePrice || 0), 0)) },
    totalTax () { return amount(this.form.items.reduce((sum, item) => sum + this.taxValue(item), 0)) },
    totalWithTax () { return amount(Number(this.totalAmount) + Number(this.totalTax)) },
    discountAmount () { return amount(this.form.wholeDiscountAmount) },
    actualAmount () { return amount(Number(this.totalWithTax) - Number(this.discountAmount)) },
    sourceActiveOrder () { return this.sourceActiveOrderId == null ? null : this.sourceSelectedOrders[String(this.sourceActiveOrderId)] || null },
    sourceActiveItems () { return this.sourceActiveOrderId == null ? [] : this.sourceItemsByOrder[String(this.sourceActiveOrderId)] || [] },
    sourceSelectedItemCount () { return Object.keys(this.sourceSelectedItemIdsByOrder).reduce((sum, key) => sum + (this.sourceSelectedItemIdsByOrder[key] || []).length, 0) },
    sourceOrderRowSelection () {
      return {
        type: 'radio',
        selectedRowKeys: this.sourceSelectedOrderIds,
        onChange: this.onSourceOrderSelectionChange,
        // Ant Design Vue 1.x requires native checkbox attributes under `props`.
        getCheckboxProps: record => ({ props: { disabled: !this.isSourceOrderCompatible(record) } })
      }
    },
    sourceItemRowSelection () {
      const key = this.sourceActiveOrderId == null ? '' : String(this.sourceActiveOrderId)
      return { selectedRowKeys: this.sourceSelectedItemIdsByOrder[key] || [], onChange: (keys, rows) => this.onSourceItemSelectionChange(key, keys, rows) }
    },
    rowSelection () {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (keys, rows) => {
          const keySet = {}
          ;(keys || []).forEach(key => { keySet[String(key)] = true })
          const next = {}
          Object.keys(this.selectedRecords).forEach(key => {
            if (keySet[key]) next[key] = this.selectedRecords[key]
          })
          ;(rows || []).forEach(row => { next[this.rowKey(row)] = row })
          this.selectedRowKeys = keys || []
          this.selectedRecords = next
        }
      }
    }
  },
  created () { this.load(); this.refreshWarehouses(); this.loadUsers(); this.loadBaseOptions(); window.addEventListener('resize', this.updateViewport); this.consumeSourceOrderQuery(); this.consumeOutboundIdQuery() },
  beforeDestroy () { window.removeEventListener('resize', this.updateViewport) },
  activated () { this.refreshWarehouses(); this.load(); this.consumeSourceOrderQuery(); this.consumeOutboundIdQuery() },
  watch: {
    '$route.query.sourceOrderId' () { this.consumeSourceOrderQuery() },
    '$route.query.outboundId' () { this.consumeOutboundIdQuery() }
  },
  methods: {
    refreshWarehouses () { listWarehouse(true).then(res => { this.warehouses = res.data || [] }) },
    loadUsers () { pageUser({ pageNum: 1, pageSize: 500, status: 1 }).then(res => { this.userOptions = (res.data && res.data.records) || [] }).catch(() => { this.userOptions = [] }) },
    loadBaseOptions () {
      const mapOptions = res => (res.data || []).map(item => ({ value: item.dictValue, label: item.dictLabel }))
      getDicts('erp_settlement_method').then(res => { this.settlementMethodOptions = mapOptions(res) })
      getDicts('erp_delivery_method').then(res => { this.deliveryMethodOptions = mapOptions(res) })
    },
    updateViewport () { this.viewportWidth = window.innerWidth },
    closeDrawer () { this.drawerVisible = false },
    formatMoney: amount,
displayValue (value) { return value === null || value === undefined || value === '' ? '—' : value },
    optionLabel (options, value) { const option = options.find(item => String(item.value) === String(value)); return option ? option.label : this.displayValue(value) },
    settlementStatusText (value) { return ({ unsettled: '未结算', partial: '部分结算', settled: '已结算' })[value] || this.displayValue(value) },
    rowKey (record) { return `${record.id}-${record.sourceOrderId || 'source'}` },
    rowPrintKey (record) { return record && record.id != null ? String(record.id) : '' },
    blobFromResponse (res) { return (res && res.data !== undefined ? res.data : res) },
    printItemsOf (records) {
      return (records || []).filter(row => row && row.id != null).map(row => ({
        id: row.id,
        sourceOrderId: row.sourceOrderId || undefined
      }))
    },
    async printDocuments (records, loadingKey) {
      const items = this.printItemsOf(records)
      if (!items.length) {
        this.$message.warning('请先勾选要打印的销售出库单')
        return
      }
      if (loadingKey) this.printingId = loadingKey
      else this.batchPrinting = true
      try {
        const res = await printSalesOutbound(items)
        await printPdfBlob(this.blobFromResponse(res))
      } catch (e) {
        this.$message.error((e && e.message) || '打印失败')
      } finally {
        if (loadingKey) this.printingId = null
        else this.batchPrinting = false
      }
    },
    printRow (record) {
      return this.printDocuments([record], this.rowPrintKey(record))
    },
    printSelected () {
      return this.printDocuments(Object.keys(this.selectedRecords).map(key => this.selectedRecords[key]))
    },
    salesUserLabel (value) {
      if (Array.isArray(value)) return value.map(this.userLabel).filter(label => label !== '—').join('、') || '—'
      return this.userLabel(value)
    },
    userLabel (id) { if (id === null || id === undefined || id === '') return '—'; const user = this.userOptions.find(item => String(item.id) === String(id)); return user ? (user.nickName || user.userName) : `用户 #${id}` },
statusText (s) { return { unaudited: '未审核', audited: '已审核', reverse_audited: '已反审核' }[s] || s },
    statusColor (s) { return { unaudited: 'orange', audited: 'green', reverse_audited: 'blue' }[s] || 'default' },
    warehouseName (id) { const row = this.warehouses.find(x => String(x.id) === String(id)); return row ? row.warehouseName : (id == null ? '' : String(id)) },
    taxValue (item) {
      if (!this.editable && item.taxAmount != null) return Number(item.taxAmount || 0)
      const base = Number(item.qtyBusiness || 0) * Number(item.salePrice || 0)
      return Number(amount(base * Number(item.taxRate || 0) / 100))
    },
    lineTax (item) { return amount(this.taxValue(item)) },
    lineTotal (item) { return amount(Number(item.qtyBusiness || 0) * Number(item.salePrice || 0) + this.taxValue(item)) },
    load () {
      this.loading = true
      pageSalesOutbound({ ...this.query, dateStart: this.dateRange[0] && this.dateRange[0].format('YYYY-MM-DD'), dateEnd: this.dateRange[1] && this.dateRange[1].format('YYYY-MM-DD'), pageNum: this.pagination.current, pageSize: this.pagination.pageSize }).then(res => {
        const data = res.data || {}; this.rows = data.records || []; this.pagination.total = Number(data.total || 0)
      }).finally(() => { this.loading = false })
    },
    search () { this.pagination.current = 1; this.selectedRowKeys = []; this.selectedRecords = {}; this.load() },
    reset () { this.query = { outboundNo: '', customerKeyword: '', auditStatus: undefined, settlementStatus: undefined, sourceOrderNo: '', warehouseId: undefined, salesUserId: undefined }; this.dateRange = []; this.search() },
    onPageChange (page) { this.pagination.current = page.current; this.pagination.pageSize = page.pageSize; this.load() },
    openCreate () { this.form = blankForm(); this.readOnly = false; this.drawerVisible = true },
    consumeSourceOrderQuery () {
      const orderId = this.$route.query && this.$route.query.sourceOrderId
      if (orderId == null || orderId === '') return
      const token = String(orderId) + ':' + String((this.$route.query && this.$route.query.outboundAt) || '')
      if (this.consumingSourceOrderId === token) return
      this.consumingSourceOrderId = token
      const query = { ...this.$route.query }
      delete query.sourceOrderId
      delete query.outboundAt
      this.$router.replace({ path: this.$route.path, query }).catch(() => {})
      this.openCreateFromOrder(String(orderId))
    },
    consumeOutboundIdQuery () {
      const outboundId = this.$route.query && this.$route.query.outboundId
      if (outboundId == null || outboundId === '') return
      const token = String(outboundId) + ':' + String((this.$route.query && this.$route.query.openedAt) || '')
      if (this.consumingOutboundIdToken === token) return
      this.consumingOutboundIdToken = token
      const query = { ...this.$route.query }
      delete query.outboundId
      delete query.openedAt
      this.$router.replace({ path: this.$route.path, query }).catch(() => {})
      this.openDetail({ id: outboundId })
    },
    openCreateFromOrder (orderId) {
      this.form = blankForm()
      this.readOnly = false
      this.drawerVisible = true
      return Promise.all([getSalesOrder(orderId), getOutboundSourceItems(orderId)]).then(([orderRes, itemRes]) => {
        const order = orderRes.data || {}
        const items = itemRes.data || []
        if (order.hasOutboundDocument) {
          this.$message.warning('销售订单只支持创建一次出库单')
          return
        }
        if (!items.length) {
          this.$message.warning('该销售订单没有可出库的商品')
          return
        }
        this.form.customerId = order.customerId
        this.form.customerName = order.customerName || ''
        this.form.operatingSubjectId = order.operatingSubjectId
        this.form.warehouseId = order.deliveryWarehouseId
        this.form.items = items.map(item => this.toOutboundLine(order, item))
      }).catch(err => {
        this.$message.error((err && err.message) || '加载销售订单商品失败')
      })
    },
    toOutboundLine (order, item) {
      const businessQty = toSalesQty(item, 'qtyRemaining')
      const line = {
        sourceOrderId: order.id,
        sourceOrderNo: order.orderNo,
        sourceOrderItemId: item.id,
        skuId: item.skuId,
        skuCode: item.skuCode,
        skuName: item.skuName,
        unitId: item.unitId,
        unitName: item.unitName,
        convertRateToBase: item.convertRateToBase,
        qtyRemaining: businessQty,
        qtyBusiness: businessQty,
        salePrice: item.salePrice,
        taxRate: item.taxRate || 0
      }
      line.taxAmount = Number(amount(businessQty * Number(item.salePrice || 0) * Number(item.taxRate || 0) / 100))
      return line
    },
    directionChanged () {
      this.form.sourceOutboundId = null
      this.form.customerId = null
      this.form.customerName = ''
      this.form.operatingSubjectId = null
      this.form.warehouseId = null
      this.form.wholeDiscountAmount = 0
      this.form.items = []
    },
    openDetail (record, edit = false) {
      getSalesOutbound(record.id).then(res => {
        this.form = res.data || blankForm(); this.readOnly = !edit
        this.form.documentDirection = this.form.documentDirection || 'outbound'
        this.form.items = this.form.items || []
        this.drawerVisible = true
      })
    },
    openSourcePicker () {
      this.sourceVisible = true
      this.sourceQuery = { customerName: '', keyword: '' }
      this.sourcePagination.current = 1
      this.sourceSelectedOrderIds = []
      this.sourceSelectedOrders = {}
      this.sourceActiveOrderId = null
      this.sourceItemsByOrder = {}
      this.sourceSelectedItemIdsByOrder = {}
      this.sourceSelectionVersion++
      this.loadSources()
    },
    onSourcePageChange (page) { this.sourcePagination.current = page.current; this.loadSources() },
    resetSourceSearch () { this.sourceQuery = { customerName: '', keyword: '' }; this.sourcePagination.current = 1; this.loadSources() },
    loadSources () {
      this.sourceLoading = true
      const filter = { ...this.sourceQuery, documentDirection: this.form.documentDirection, pageNum: this.sourcePagination.current, pageSize: this.sourcePagination.pageSize }
      if (this.form.customerId != null) { filter.customerId = this.form.customerId; filter.operatingSubjectId = this.form.operatingSubjectId; if (!this.isReturn) filter.warehouseId = this.form.warehouseId }
      pageOutboundSourceOrders(filter).then(res => { this.sourceRows = (res.data && res.data.records) || []; this.sourcePagination.total = Number((res.data && res.data.total) || 0) }).finally(() => { this.sourceLoading = false })
    },
    isSourceOrderCompatible (order) {
      const locked = (this.form.items || []).find(item => item.sourceOrderId != null)
      if (locked && String(locked.sourceOrderId) !== String(order.id)) return false
      return true
    },
    sourceOrderRowClass (record) { return String(record.id) === String(this.sourceActiveOrderId) ? 'source-order-active' : '' },
    sourceItemRowKey (record) { return this.isReturn ? record.sourceOutboundItemId : record.id },
    activateSourceOrder (order, ensureSelected) {
      if (!this.isSourceOrderCompatible(order)) { this.$message.warning('一张出库单只能选择一张销售订单'); return }
      if (ensureSelected) {
        Object.keys(this.sourceSelectedOrders).forEach(key => { if (key !== String(order.id)) this.$delete(this.sourceSelectedOrders, key) })
        Object.keys(this.sourceSelectedItemIdsByOrder).forEach(key => { if (key !== String(order.id)) this.$delete(this.sourceSelectedItemIdsByOrder, key) })
        this.sourceSelectedOrderIds = [String(order.id)]
        this.$set(this.sourceSelectedOrders, String(order.id), order)
        this.$nextTick(() => { this.sourceSelectionVersion++ })
      }
      this.sourceActiveOrderId = order.id
      this.loadSourceItemsForOrder(order)
    },
    onSourceOrderSelectionChange (keys, rows) {
      if (keys.length > 1) { keys = keys.slice(-1); rows = rows.slice(-1) }
      const acceptedRows = rows.filter(order => this.isSourceOrderCompatible(order))
      if (acceptedRows.length !== rows.length) this.$message.warning('一张出库单只能选择一张销售订单')
      const acceptedKeys = acceptedRows.map(order => String(order.id))
      const keep = new Set(acceptedKeys.map(String))
      Object.keys(this.sourceSelectedOrders).forEach(key => { if (!keep.has(key)) this.$delete(this.sourceSelectedOrders, key) })
      Object.keys(this.sourceSelectedItemIdsByOrder).forEach(key => { if (!keep.has(key)) this.$delete(this.sourceSelectedItemIdsByOrder, key) })
      acceptedRows.forEach(order => { this.$set(this.sourceSelectedOrders, String(order.id), order) })
      this.sourceSelectedOrderIds = acceptedKeys
      if (!acceptedKeys.length) { this.sourceActiveOrderId = null; this.$nextTick(() => { this.sourceSelectionVersion++ }); return }
      if (!keep.has(String(this.sourceActiveOrderId))) this.sourceActiveOrderId = acceptedKeys[0]
      acceptedRows.forEach(order => this.loadSourceItemsForOrder(order))
      this.$nextTick(() => { this.sourceSelectionVersion++ })
    },
    loadSourceItemsForOrder (order) {
      const key = String(order.id)
      if (this.sourceItemsByOrder[key]) return
      this.sourceItemLoading = true
      ;(this.isReturn ? getReturnSourceItems : getOutboundSourceItems)(order.id).then(res => {
        const items = (res.data || []).map(item => ({ ...item, salesAttribute: '常规销售' }))
        this.$set(this.sourceItemsByOrder, key, items)
        if (!this.sourceSelectedItemIdsByOrder[key]) this.$set(this.sourceSelectedItemIdsByOrder, key, [])
      }).finally(() => { this.sourceItemLoading = false })
    },
    onSourceItemSelectionChange (key, keys, rows) {
      if (this.isReturn && rows.length) {
        const outboundId = rows[0].sourceOutboundId
        const acceptedRows = rows.filter(row => String(row.sourceOutboundId) === String(outboundId))
        if (acceptedRows.length !== rows.length) this.$message.warning('一张退货单只能选择同一张原销售出库单的明细')
        keys = acceptedRows.map(row => row.sourceOutboundItemId)
      }
      this.$set(this.sourceSelectedItemIdsByOrder, key, keys)
    },
    addSelectedItems () {
      if (!this.sourceSelectedItemCount) { this.$message.warning('请先勾选要出库的商品明细'); return }
      if (this.sourceSelectedOrderIds.length > 1) { this.$message.warning('一张出库单只能选择一张销售订单'); return }
      const selectedOrderId = this.sourceSelectedOrderIds[0]
      const existing = (this.form.items || []).find(item => item.sourceOrderId != null)
      if (existing && String(existing.sourceOrderId) !== String(selectedOrderId)) { this.$message.warning('一张出库单只能选择一张销售订单'); return }
      const firstOrder = this.sourceSelectedOrders[String(selectedOrderId)]
      if (this.form.customerId == null && firstOrder) { this.form.customerId = firstOrder.customerId; this.form.customerName = firstOrder.customerName; this.form.operatingSubjectId = firstOrder.operatingSubjectId; if (!this.isReturn) this.form.warehouseId = firstOrder.deliveryWarehouseId }
      for (const orderId of this.sourceSelectedOrderIds) {
        const key = String(orderId)
        const order = this.sourceSelectedOrders[key]
        const selected = new Set((this.sourceSelectedItemIdsByOrder[key] || []).map(String))
        for (const item of (this.sourceItemsByOrder[key] || []).filter(row => selected.has(String(this.isReturn ? row.sourceOutboundItemId : row.id)))) {
          if (this.form.items.some(x => String(this.isReturn ? x.sourceOutboundItemId : x.sourceOrderItemId) === String(this.isReturn ? item.sourceOutboundItemId : item.id))) continue
          if (this.isReturn) {
            if (this.form.sourceOutboundId != null && String(this.form.sourceOutboundId) !== String(item.sourceOutboundId)) { this.$message.warning('一张退货单只能关联一张原出库单'); return }
            this.form.sourceOutboundId = item.sourceOutboundId
            this.form.warehouseId = item.warehouseId
            this.form.operatingSubjectId = item.operatingSubjectId
            const newItem = { ...item, sourceOrderId: order.id, sourceOrderNo: order.orderNo, sourceOrderItemId: item.sourceOrderItemId, sourceOutboundItemId: item.sourceOutboundItemId, unitId: item.unitId, unitName: item.unitName, convertRateToBase: item.convertRateToBase, qtyBusiness: -Number(item.qtyReturnable || 0), salePrice: item.salePrice, taxRate: item.taxRate || 0 }
            this.form.items.push(newItem)
            continue
          }
          const businessQty = toSalesQty(item, 'qtyRemaining')
          const newItem = { sourceOrderId: order.id, sourceOrderNo: order.orderNo, sourceOrderItemId: item.id, skuId: item.skuId, skuCode: item.skuCode, skuName: item.skuName, unitId: item.unitId, unitName: item.unitName, convertRateToBase: item.convertRateToBase, qtyRemaining: businessQty, qtyBusiness: businessQty, salePrice: item.salePrice, taxRate: item.taxRate || 0 }
          newItem.taxAmount = Number(amount(businessQty * Number(item.salePrice || 0) * Number(item.taxRate || 0) / 100))
          this.form.items.push(newItem)
        }
      }
      this.sourceVisible = false
    },
    save () {
      if (!this.form.outboundDate || !this.form.items.length) { this.$message.warning('请填写出库日期并选择订单明细'); return }
      if (this.form.items.some(x => (this.isReturn ? Number(x.qtyBusiness) >= 0 : Number(x.qtyBusiness) <= 0) || x.salePrice == null || Number(x.taxRate || 0) < 0)) { this.$message.warning(this.isReturn ? '退货数量必须为负数，且单价、税率不能小于0' : '请逐行填写正确的出库数量、单价和税率'); return }
      if (!this.isReturn && Number(this.form.wholeDiscountAmount || 0) > Number(this.totalWithTax)) { this.$message.warning('整单折扣金额不能大于结算金额'); return }
      this.saving = true
      const payload = { id: this.form.id, outboundDate: this.form.outboundDate, documentDirection: this.form.documentDirection, sourceOutboundId: this.form.sourceOutboundId, warehouseId: this.form.warehouseId, wholeDiscountAmount: this.form.wholeDiscountAmount || 0, prepaidAccountName: this.form.prepaidAccountName, attachmentUrl: this.form.attachmentUrl, remark: this.form.remark, items: this.form.items.map(x => ({ sourceOrderId: x.sourceOrderId, sourceOrderItemId: x.sourceOrderItemId, sourceOutboundItemId: x.sourceOutboundItemId, qtyBusiness: x.qtyBusiness, salePrice: x.salePrice, taxRate: x.taxRate || 0 })) }
      ;(payload.id ? updateSalesOutbound : createSalesOutbound)(payload).then(() => { this.$message.success('草稿已保存，尚未扣减库存'); this.drawerVisible = false; this.load() }).finally(() => { this.saving = false })
    },
    confirmAction (verb, record, action) {
      const isReturn = record.documentDirection === 'return'
      const note = verb === '审核' ? (isReturn ? '审核后将按原出库单单位换算成基本单位增加库存，并固定负数退货金额。' : '审核后将按销售订单单位换算成基本单位扣减库存，并固定本单的出库金额。') : verb === '反审核' ? (isReturn ? '仅在没有有效下游单据且返回库存未被后续使用时可反审核。' : '仅在没有有效下游单据时可反审核；库存与订单剩余量将恢复。') : verb === '删除' ? '软删除后列表不再显示，审计记录保留。' : '作废后需再删除，单据才会从列表隐藏。'
      this.$confirm({ title: '确认' + verb + ' ' + record.outboundNo + '？', content: note, onOk: () => action(record.id).then(() => { this.$message.success(verb + '成功'); this.load() }) })
    },
    attachmentChanged (value) { this.form.attachmentUrl = typeof value === 'string' ? value : (value && (value.attachmentUrl || value.path)) || '' },
    auditSalesOutbound,
reverseAuditSalesOutbound,
voidSalesOutbound,
deleteSalesOutbound
  }
}
</script>

<style lang="less" scoped>
.empty-lines { padding: 24px; }
.outbound-line-table { min-width: 1080px; }
.source-cell { min-width: 170px; strong, span { display: block; } span { margin-top: 3px; color: #5d6b7c; } }
.readonly-tax { color: #506176; font-variant-numeric: tabular-nums; white-space: nowrap; }
.outbound-summary { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 14px 4px 0; color: #7c899a; > div { display: flex; gap: 28px; } b { color: #2c3947; } strong { color: #225fae; font-size: 19px; font-variant-numeric: tabular-nums; } }
.source-picker-shell { position: relative; min-height: 680px; padding: 0 12px 74px; background: oklch(97.8% 0.006 250); color: #2e3b4e; }
.source-picker-intro { display: flex; align-items: center; gap: 10px; min-height: 48px; padding: 0 2px; strong { font-size: 15px; color: #243247; } span { color: #7b8798; font-size: 12px; } }
.source-search-grid { display: grid; grid-template-columns: minmax(220px, .8fr) minmax(360px, 1.7fr) auto; gap: 12px; align-items: end; margin: 0 0 12px; padding: 14px 16px; border: 1px solid oklch(90% 0.012 250); border-radius: 8px; background: #fff;
  label { display: grid; gap: 6px; min-width: 0; > span { color: #637084; font-size: 12px; font-weight: 500; } }
}
.source-search-actions { display: flex; gap: 8px; padding-bottom: 1px; }
.source-picker-panel { overflow: hidden; margin-bottom: 12px; border: 1px solid oklch(89.5% 0.013 250); border-radius: 8px; background: #fff; box-shadow: 0 1px 2px rgba(30, 48, 75, .035); }
.source-panel-heading { display: flex; align-items: center; justify-content: space-between; min-height: 42px; padding: 0 12px; border-bottom: 1px solid oklch(91.5% 0.01 250); background: oklch(98.3% 0.004 250); color: #7b8797; font-size: 12px;
  > div { display: flex; align-items: baseline; gap: 10px; min-width: 0; }
  strong { color: #2d3a4e; font-size: 14px; }
  small { overflow: hidden; color: #8793a3; text-overflow: ellipsis; white-space: nowrap; }
  b { color: #1769d2; font-variant-numeric: tabular-nums; }
}
.source-item-empty { padding: 54px 0 66px; }
.source-picker-footer { position: absolute; right: 0; bottom: 0; left: 0; z-index: 2; display: flex; align-items: center; justify-content: flex-end; gap: 10px; height: 62px; padding: 0 18px; border-top: 1px solid oklch(89.5% 0.012 250); background: rgba(255, 255, 255, .96); box-shadow: 0 -4px 18px rgba(34, 52, 78, .06); backdrop-filter: blur(6px); }
/deep/ .outbound-source-modal .ant-modal { top: 18px; padding-bottom: 18px; }
/deep/ .outbound-source-modal .ant-modal-header { padding: 14px 20px; border-bottom-color: oklch(89.5% 0.012 250); }
/deep/ .outbound-source-modal .ant-modal-title { color: #26354a; font-weight: 600; }
/deep/ .outbound-source-modal .ant-table { color: #3d4b5f; }
/deep/ .outbound-source-modal .ant-table-thead > tr > th { padding: 9px 12px; background: oklch(97.2% 0.006 250); color: #566478; font-size: 12px; font-weight: 600; }
/deep/ .outbound-source-modal .ant-table-tbody > tr > td { padding: 9px 12px; }
/deep/ .outbound-source-modal .ant-table-tbody > tr.source-order-active > td { background: oklch(95.5% 0.025 250); }
/deep/ .outbound-source-modal .ant-table-tbody > tr.source-order-active:hover > td { background: oklch(94.5% 0.03 250); }
/deep/ .outbound-source-modal .ant-pagination { margin: 10px 12px; }
@media (max-width: 900px) {
  .outbound-summary, .outbound-summary > div { align-items: flex-start; flex-direction: column; gap: 8px; }
  .source-picker-shell { min-height: 720px; }
  .source-search-grid { grid-template-columns: 1fr; }
  .source-search-actions { justify-content: flex-end; }
  .source-panel-heading { align-items: flex-start; flex-direction: column; gap: 4px; padding-top: 8px; padding-bottom: 8px; }
}
</style>
